import { useEffect, useMemo, useState } from "react";
import { Bell, X } from "lucide-react";
import { buildTaskNotifications, dismissNotification } from "../lib/taskReminders";
import { fmtDate } from "./UI";

export default function NotificationCenter({ tasks = [], userEmail = "", onOpenTasks }) {
  const [open, setOpen] = useState(false);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, []);

  const items = useMemo(() => buildTaskNotifications(tasks, userEmail), [tasks, userEmail, tick]);

  return (
    <div className="notification-center">
      <button type="button" className="topbar-icon-btn notification-bell" onClick={() => setOpen((o) => !o)} aria-label="Notifications">
        <Bell size={18} strokeWidth={1.75} />
        {items.length > 0 && <span className="notification-badge">{items.length > 9 ? "9+" : items.length}</span>}
      </button>
      {open && (
        <>
          <div className="notification-backdrop" onClick={() => setOpen(false)} />
          <div className="notification-panel">
            <div className="notification-panel-header">
              <strong>Task reminders</strong>
              <button type="button" className="btn btn-sm btn-ghost" onClick={() => setOpen(false)}><X size={16} /></button>
            </div>
            {items.length === 0 ? (
              <p className="text-caption" style={{ padding: 16 }}>No reminders for you right now.</p>
            ) : (
              <ul className="notification-list">
                {items.map((n) => (
                  <li key={n.id} className="notification-item">
                    <div>
                      <div className="notification-item-title">{n.title}</div>
                      <div className="notification-item-meta">{n.label} · Due {fmtDate(new Date(n.dueAt))}</div>
                    </div>
                    <button type="button" className="btn btn-sm btn-ghost" onClick={() => { dismissNotification(n.id); setTick((t) => t + 1); }}>Dismiss</button>
                  </li>
                ))}
              </ul>
            )}
            <button type="button" className="btn btn-sm" style={{ margin: 12 }} onClick={() => { onOpenTasks?.(); setOpen(false); }}>Task inbox</button>
          </div>
        </>
      )}
    </div>
  );
}
